import { render } from "./UserExpenseCard.vue?vue&type=template&id=334f5fbc&scoped=true&ts=true&lang=pug"
import script from "./UserExpenseCard.vue?vue&type=script&lang=ts"
export * from "./UserExpenseCard.vue?vue&type=script&lang=ts"

import "./UserExpenseCard.vue?vue&type=style&index=0&id=334f5fbc&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334f5fbc"]])

export default __exports__